import { render, staticRenderFns } from "./HistoricoLeads.vue?vue&type=template&id=773364dc&scoped=true&"
import script from "./HistoricoLeads.vue?vue&type=script&lang=js&"
export * from "./HistoricoLeads.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoLeads.vue?vue&type=style&index=0&id=773364dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773364dc",
  null
  
)

export default component.exports